// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E9eeU","left":"styles_left__2awGS","desktopActions":"styles_desktopActions__1tE6o","title":"styles_title__3LPhG"};